"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _BrixelSelect = _interopRequireDefault(require("./BrixelSelect"));
var _CountryCodePhone = require("../../constants/CountryCodePhone");
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
var _reactRedux = require("react-redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// eslint-disable-next-line react/display-name
const BrixelInputPhone = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    autofocus,
    className,
    classNameInput,
    disableAutocomplete,
    disabled,
    errorMessage,
    input,
    isLoading,
    isLoadingColorClass = 'Dark700',
    label,
    large = false,
    message = {
      help: null,
      error: null
    },
    meta = {
      dirty: false,
      invalid: false
    },
    placeholder = '',
    showError,
    tooltip
  } = props;
  // STATE
  const [containerWidth, setContainerWidth] = (0, _react.useState)(0);
  const [optionsSelectPhone, setOptionsSelectPhone] = (0, _react.useState)([]);
  const [flagPadding, setFlagPadding] = (0, _react.useState)(0);
  const [showErrorState, setShowErrorState] = (0, _react.useState)(showError);
  const [currentValue, setCurrentValue] = (0, _react.useState)(input.value);
  // REF
  const inputContainerRef = (0, _react.useRef)(null);
  const selectRef = (0, _react.useRef)(null);
  const inputContainerEl = inputContainerRef.current;
  (0, _react.useEffect)(() => {
    const phoneSelect = [];
    _CountryCodePhone.phonecode.forEach(item => {
      phoneSelect.push({
        label: item.code,
        value: item.dial_code,
        country: item.name,
        flag: item.flag
      });
    });
    setOptionsSelectPhone(phoneSelect);
  }, []);
  (0, _react.useEffect)(() => {
    setShowErrorState(showError);
  }, [showError]);
  (0, _react.useEffect)(() => {
    if (currentValue?.number !== input?.value?.number || currentValue?.prefix !== input?.value?.prefix) {
      setCurrentValue(input?.value);
    }
  }, [input.value]);
  // calculate input padding for tel format
  (0, _react.useEffect)(() => {
    if (inputContainerEl) {
      setContainerWidth((0, _get.default)(inputContainerEl, 'offsetWidth', 0));
      const handleResize = () => {
        setContainerWidth((0, _get.default)(inputContainerEl, 'offsetWidth', 0));
      };
      if (typeof window !== 'undefined') window.addEventListener('resize', handleResize);
    }
  });
  const onChange = (val, type) => {
    const newValue = {
      ...currentValue
    };
    newValue[type] = val;
    setCurrentValue(newValue);
    if (input.onChange) input.onChange(newValue);
  };
  const onBlur = e => {
    if (input.onBlur) input.onBlur(e);
  };
  // generate css classes fuctions
  const inputClassFunc = () => {
    let inClasses = 'desktop';
    if (large) inClasses += ' large ';
    return inClasses;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${className} phoneNumber`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: `brixel-label ${disabled ? 'disabledLabel' : ''} ${tooltip ? 'wTooltip' : ''} ${large ? 'labelLarge' : ''}`,
    htmlFor: input.name
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), tooltip && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col brixel-text-input-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f jc-b a-c"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r w-perc-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-perc-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c pos-r input-container",
    ref: inputContainerRef
  }, /*#__PURE__*/_react.default.createElement(_BrixelSelect.default, {
    disabled: disabled,
    forwardedRef: selectRef,
    flags: true,
    large: large,
    flagWrapperWidth: containerWidth,
    options: optionsSelectPhone,
    input: {
      name: `${input.name}_prefix`,
      value: currentValue?.prefix,
      onChange: val => onChange(val, 'prefix'),
      changePadding: val => setFlagPadding(val || 0)
    }
  }), /*#__PURE__*/_react.default.createElement("input", {
    role: 'text',
    id: input.name,
    "data-validation": false,
    autoComplete: disableAutocomplete ? 'chrome-off' : '',
    className: `brixel-text-input ${inputClassFunc()} ${classNameInput}`,
    value: currentValue?.number,
    name: `${input.name}_number`,
    disabled: disabled,
    placeholder: placeholder,
    type: "number",
    onChange: e => onChange(e.target.value, 'number'),
    onBlur: e => onBlur(e),
    ref: ref,
    autoFocus: autofocus,
    pattern: "\\\\d*",
    inputMode: 'text',
    style: {
      paddingLeft: flagPadding
    },
    onWheel: e => e.currentTarget.blur()
  }), placeholder && (/*#__PURE__*/_react.default.createElement("span", {
    className: "hiddentext"
  }, placeholder)))), isLoading && (/*#__PURE__*/_react.default.createElement("div", {
    className: "inputLoader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  })))), meta.dirty === true && meta.invalid && showErrorState && (0, _get.default)(message, 'error', true) !== true && !isLoading && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "validation-icon error largeTop",
    icon: "alert"
  })))), (0, _get.default)(message, 'help', null) || (0, _get.default)(meta, 'invalid', null) && showErrorState ? (/*#__PURE__*/_react.default.createElement("span", {
    className: `message ${(0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) ? 'error-message' : ''}`
  }, errorMessage || (0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) && showErrorState ? (0, _get.default)(message, 'error', '') : (0, _get.default)(message, 'help', ''))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null))));
});
const mapStateToProps = state => ({
  translations: (0, _get.default)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelInputPhone);